import * as Yup from 'yup';

const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

const validationSchema = Yup.object({
    password: Yup.string()
        .max(255, 'Password must be 255 characters or less')
        .matches(
            PASSWORD_REGEX,
            'Password must be at least 8 characters long, include at least one letter, one number, and one special character'
        )
        .required('Password is required'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required')
});

export default validationSchema;
